import { render } from "./ViewInstructors.vue?vue&type=template&id=4d94f19e&scoped=true"
import script from "./ViewInstructors.vue?vue&type=script&lang=js"
export * from "./ViewInstructors.vue?vue&type=script&lang=js"

import "./ViewInstructors.vue?vue&type=style&index=0&id=4d94f19e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d94f19e"]])

export default __exports__